import React, { useEffect, useRef, useState } from 'react';
import "../styles/mainDesign.css";
import { baseUrl } from '../config';
import image1 from '../assets/img/Pre-prod.png';
import img2  from '../assets/img/Production.png';
import img3 from '../assets/img/post-product b.png';



const ScrollRevealSections = () => {
    const [activeIndex, setActiveIndex] = useState(0);

    const sections = [
        {
            id: "Pre-Production",
            title: "Pre-Production",
            description: "Consolidate all events, plans, and off-periods across your production to a single calendar for your entire team to see.",
            image: image1,
            icon: "🎬"
        },
        {
            id: "Production",
            title: "Production",
            description: "Get a clear picture of the entirety of production – from prep to shoot to post, all on the Gantt Chart.",
            image: img2,
            icon: "🎥"
        },
        {
            id: "Post-Production",
            title: "Post-Production",
            description: "Your one-stop hub for everyone: bring teams together, collaborate and share information across the board.",
            image: img3,
            icon: "🎞️"
        }
    ];

    const sectionRefs = useRef([]);
    const lineRefs = useRef([]);

    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        const index = parseInt(entry.target.getAttribute('data-index'));
                        setActiveIndex(index);

                        // Update line heights
                        lineRefs.current.forEach((line, i) => {
                            if (i < index) {
                                line.style.transform = 'scaleY(1)';
                            } else if (i === index) {
                                const progress = (entry.intersectionRatio - 0.5) * 2;
                                line.style.transform = `scaleY(${Math.max(0.1, Math.min(1, progress))})`;
                            } else {
                                line.style.transform = 'scaleY(0.1)';
                            }
                        });
                    }
                });
            },
            {
                threshold: [0, 0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1],
                rootMargin: '-45% 0px -45% 0px'
            }
        );

        sectionRefs.current.forEach(ref => {
            if (ref) observer.observe(ref);
        });

        return () => observer.disconnect();
    }, []);

    return (
        <div className="md-container">
            {/* Left side - sticky, shows only the active section's large image card */}
            <div className="md-sticky-col">
                {sections.map((section, index) => (
                    <div
                        key={section.id}
                        className={`md-left-section ${
                            index === activeIndex
                                ? 'md-state-active'
                                : index < activeIndex
                                    ? 'md-state-before'
                                    : 'md-state-after'
                        }`}
                    >
                        <div className="md-image-card">
                            <img src={section.image} alt={section.title} className="md-image" />
                        </div>
                    </div>
                ))}
            </div>

            {/* Right side - Scrollable content, each section now carries its own
                timeline marker + connecting track */}
            <div className="md-content-col">
                <div className="md-scroll-track">
                    {sections.map((section, index) => (
                        <div
                            key={section.id}
                            ref={el => sectionRefs.current[index] = el}
                            data-index={index}
                            className="md-scroll-section"
                        >
                            <div className="md-scroll-marker-col">
                                <div className={`md-marker ${index <= activeIndex ? 'md-marker-done' : ''}`} />

                                {/* Vertical line indicator - same lineRefs/scaleY logic as before,
                                    only relocated to sit between this section and the next one. */}
                                {index < sections.length - 1 && (
                                    <div className="md-progress-track">
                                        <div
                                            ref={el => lineRefs.current[index] = el}
                                            className="md-progress-fill"
                                            style={{ transform: 'scaleY(0.1)' }}
                                        />
                                    </div>
                                )}
                            </div>
                            <div
                                className={`md-scroll-content ${
                                    index === activeIndex
                                        ? 'md-state-active'
                                        : index < activeIndex
                                            ? 'md-state-before'
                                            : 'md-state-after'
                                }`}
                            >
                                <span className="md-section-icon">{section.icon}</span>
                                <div>
                                    <h2 className="md-section-title">{section.title}</h2>
                                    <p className="md-section-desc">{section.description}</p>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default ScrollRevealSections;
